import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';

export const useReportingFeatureAccess = (): {
  canAccessReporting: boolean;
  isLoading: boolean;
} => {
  const {
    enterpriseData: { isInternalAdminUser },
  } = useAuth();
  const { value: isReportingEnabled, isLoading: isLoadingReporting } =
    useFeatureFlag(FeatureFlag.ENABLE_REPORTING_FEATURE);
  const { value: isInternalOnlyPhase, isLoading: isLoadingInternalOnly } =
    useFeatureFlag(FeatureFlag.REPORTING_INTERNAL_ONLY_PHASE);

  const canAccessReporting =
    isReportingEnabled && (!isInternalOnlyPhase || isInternalAdminUser);

  return {
    canAccessReporting,
    isLoading: isLoadingReporting || isLoadingInternalOnly,
  };
};
